export default __webpack_public_path__ + "static/media/ico_security.8474e903.svg";